module.exports = __webpack_public_path__ + "media/images/planning_a_trip_to_japan/id/1/4-4857a09f26ecb4fc315f5cb68b18b6e3.jpg";